import React, { useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import styles from './results-section.module.scss'

/**
 * One resulting course: student count, "% preferencias logradas", a criteria balance summary
 * (per evaluation dimension, a count per distinct value - e.g. "liderazgo: + (5), - (3)"), and
 * the student list. When `isEditable`, doubles as a native HTML5 drag & drop zone - dragging a
 * student chip out fires `onDropStudent` on whichever CourseCard it lands on; no library needed
 * for a plain "move a card between lists" interaction.
 */
const CourseCard = ({ course, isEditable, onDropStudent }) => {
  const [t] = useTranslation('translation', { keyPrefix: 'pages.data.courseAssignmentPeriodDashboard' })
  const [isDragOver, setIsDragOver] = useState(false)

  const criteriaSummary = Object.entries(course.criteriaBalance || {}).map(([dimension, counts]) => {
    const countsText = Object.entries(counts).map(([value, count]) => `${value} (${count})`).join(', ')
    return `${dimension}: ${countsText}`
  })

  const handleDragOver = (event) => {
    if (!isEditable) return
    event.preventDefault()
    setIsDragOver(true)
  }

  const handleDrop = (event) => {
    if (!isEditable) return
    event.preventDefault()
    setIsDragOver(false)
    const resultStudentId = event.dataTransfer.getData('text/plain')
    if (resultStudentId) onDropStudent(resultStudentId, course.name)
  }

  return (
    <div
      data-testid={`course-card-${course.id}`}
      className={classNames(styles.upload_wrapper, { [styles.drag_over]: isDragOver })}
      onDragOver={handleDragOver}
      onDragLeave={() => setIsDragOver(false)}
      onDrop={handleDrop}
    >
      <p><strong>{course.name}</strong> — {t('resultStudentCount', { count: course.studentCount })}</p>
      <p>
        {course.preferencesAchievedPercent === null
          ? t('resultNoPreferencesData')
          : t('resultPreferencesAchieved', { percent: course.preferencesAchievedPercent })}
      </p>
      {criteriaSummary.length > 0 && (
        <p className={styles.criteria_balance}>
          {t('resultCriteriaBalance')}: {criteriaSummary.join(' · ')}
        </p>
      )}
      <ul className={styles.students_list}>
        {course.students.map(student => (
          <li
            key={student.id}
            draggable={isEditable}
            onDragStart={(event) => event.dataTransfer.setData('text/plain', String(student.id))}
            className={isEditable ? styles.draggable_student : undefined}
          >
            {student.name}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CourseCard
